<template>
  <div>
    <detail-card
      v-for="(document, d) in items"
      :key="`${document.id}${d}`"
      :medical-record-id="id"
      :document="document"
      :can-sign="canSign"
    />
  </div>
</template>

<script>
import DetailCard from './DetailCard.vue';

export default {
  components: {
    DetailCard,
  },
  props: {
    id: {
      type: String,
    },
    items: {
      type: Array,
    },
    canSign: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
